import { Fragment, createElement, createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const IsHoverTargetContext = /*#__PURE__*/createContext(false);
export default function icon(viewBox, title, ...paths) {
  const pathsElement = /*#__PURE__*/createElement(Fragment, null, ...paths);
  return function Icon(props) {
    const {
      size = 16,
      title: customTitle,
      ...rest
    } = props;
    const isHoverTarget = useContext(IsHoverTargetContext);

    if (customTitle === null && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('Setting title to null is deprecated, use `IsHoverTargetContext` instead.');
    }

    return /*#__PURE__*/_jsxs("svg", {
      role: "img",
      viewBox: viewBox,
      fill: "currentColor",
      width: size,
      height: size,
      "aria-label": customTitle || title,
      ...rest,
      children: [!isHoverTarget && customTitle !== null && /*#__PURE__*/_jsx("title", {
        children: customTitle || title
      }), pathsElement]
    });
  };
}